import { Center } from '../../lib/types/models/center/center'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type AssignLecResponsableToCentersInput = {
  lecResponsableId: number
}

export type AssignLecResponsableToCentersRequestInput = {
  centerIds: number[]
  lecResponsableId: number
}

export const assignLecResponsable = (input: AssignLecResponsableToCentersRequestInput) => {
  return restApiClient
    .url(constructApiUrl(API.centers.assignLecResponsable.url, null))
    .post<Center, AssignLecResponsableToCentersRequestInput>(input)
}
